module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.6a273c1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/notokr-medium.woff2
// module id = 5bcu
// module chunks = 0